import { Outlet, useLocation } from "react-router-dom";

const BYPASS = new Set([
  "/auth/callback",
  "/auth/echo.html",
  "/auth/smoke.html",
  "/auth/production-test.html",
  "/auth/debug-oauth.html",
]);

export default function NavigationGuard() {
  const { pathname } = useLocation();
  
  // Do NOTHING on auth callback pages - let them process OAuth without interference
  if (BYPASS.has(pathname)) {
    console.log("[NAV] NavigationGuard: BYPASSING for pathname:", pathname);
    return <Outlet />;
  }
  
  // Only log — no side effects for other routes
  console.log("[NAV] NavigationGuard: passive for pathname:", pathname);
  return <Outlet />;
}
